import { render } from "./KSKeysDragDrop.vue?vue&type=template&id=51aa8bd5"
import script from "./KSKeysDragDrop.vue?vue&type=script&lang=js"
export * from "./KSKeysDragDrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__